import { render, staticRenderFns } from "./AssignSupplierObjectiveModal.vue?vue&type=template&id=b28b6f8a"
import script from "./AssignSupplierObjectiveModal.vue?vue&type=script&lang=js"
export * from "./AssignSupplierObjectiveModal.vue?vue&type=script&lang=js"
import style0 from "./AssignSupplierObjectiveModal.vue?vue&type=style&index=0&id=b28b6f8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports